<template>
  <component :is="component" />
</template>

<script>
import salePlanTransferCheck from '../components/salePlanTransferCheck.vue'
import salePlanTransferEdit from '../salePlanTransfer.vue'
export default {
  components: {
    salePlanTransferCheck,
    salePlanTransferEdit
  },
  data() {
    return {
      component: 'salePlanTransferCheck'
    }
  },
  created() {
    const { _role } = this.$route.query
    this.component = _role === 'check' ? 'salePlanTransferCheck' : 'salePlanTransferEdit'
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/check/salePlanTransferCheck.vue